export default "__VITE_ASSET__CKqkj5T9__"